import { motion } from 'framer-motion';
import fullCycleImg from '../../assets/services/full-cycle-development.png';
import animationImg from '../../assets/services/game-animation-design.png';
import uiuxImg from '../../assets/services/game-ux-ui-design.png';
import unityImg from '../../assets/services/unity-icon.png';
import gamificationImg from '../../assets/services/gamification-expericne.png';
import qualityImg from '../../assets/services/quality-and-testing.png';
import cover_img from '../../assets/services/work-6533616_640.webp';
import blunder from '../../assets/services/Blender-Logo.png';

const services = [
  {
    image: fullCycleImg,
    title: "Full Cycle Development",
    description: "UB Creations Pvt Ltd is one of the leading game development companies offering end-to-end game development services."
  },
  {
    image: animationImg,
    title: "Game Animation Design",
    description: "Expert in creating realistic 2D as well as 3D animations. We cover a wide gamut of game art design services for our clients."
  },
  {
    image: uiuxImg,
    title: "Game UI UX Design",
    description: "We have created art assets for games, simulations, and trailers while handling full-cycle game art production."
  },
  {
    image: unityImg,
    title: "Unity Development",
    description: "At our game development studio, we have proven experience bringing visually stimulating, immersive, and seamless games to the market."
  },
  {
    image: gamificationImg,
    title: "Game Development Experience",
    description: "Comprehensive game development from scratch — from analyzing business requirements to designing, building, and delivering interactive, engaging game applications."
  },
  {
    image: qualityImg,
    title: "Quality & Testing",
    description: "Our quality assurance experts are here to test your finished game product inside and out before you present it to the general public."
  },
  {
    image: blunder,
    title: "Creative CG Artist & Modular 3D Designer",
    description: "Our expert CG artists and modular 3D designers bring your game worlds to life with stylized or realistic assets, optimized for performance and visual impact."
  },
];

const ServicesPage = () => {
  // Floating particles (same as other sections)
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    size: Math.random() * 30 + 10,
    top: Math.random() * 100,
    left: Math.random() * 100,
    delay: Math.random() * 5,
    duration: Math.random() * 10 + 5,
    opacity: Math.random() * 0.3 + 0.1,
  }));

  return (
    <div className="w-full">
      {/* Cover Image Section */}
      <div className="relative">
        <img src={cover_img} alt="Cover" className="w-full h-[400px] object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-red-900/70 to-rose-800/70 flex items-center justify-center">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-white text-4xl md:text-6xl font-['Roboto_Condensed'] font-extrabold uppercase tracking-wide"
          >
            Our Services
          </motion.h1>
        </div>
      </div>

      {/* Services Grid with white cards and particles */}
      <div className="relative py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-white via-gray-50 to-white overflow-hidden">
        {/* Floating particles background */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-200/30 rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-rose-200/30 rounded-full blur-3xl animate-pulse delay-1000" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-100/20 rounded-full blur-3xl" />
          {particles.map((particle) => (
            <div
              key={particle.id}
              className="absolute rounded-full bg-gradient-to-r from-red-400/20 to-rose-400/20 blur-xl animate-float"
              style={{
                width: `${particle.size}px`,
                height: `${particle.size}px`,
                top: `${particle.top}%`,
                left: `${particle.left}%`,
                opacity: particle.opacity,
                animation: `float ${particle.duration}s ease-in-out infinite`,
                animationDelay: `${particle.delay}s`,
              }}
            />
          ))}
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold">
              <span className="bg-gradient-to-r from-red-600 via-red-500 to-rose-500 bg-clip-text text-transparent">
                What We Do
              </span>
            </h2>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-lg">
              Delivering immersive, high-quality gaming solutions tailored for your unique business goals.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative"
              >
                <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-6 text-center transition-all duration-500 hover:bg-white hover:scale-105 hover:shadow-2xl hover:shadow-red-200/40 border border-gray-200/30 hover:border-red-300/50 h-full flex flex-col">
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-red-500/0 via-rose-500/0 to-red-500/0 group-hover:from-red-500/5 group-hover:via-rose-500/5 group-hover:to-red-500/5 transition-all duration-500" />
                  <div className="relative z-10 flex flex-col items-center">
                    <div className="w-20 h-20 rounded-full bg-red-100/80 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-12 h-12 object-contain"
                      />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 group-hover:text-red-600 transition-colors mb-2">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-15px) translateX(5px); }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default ServicesPage;